import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DetalhesComponent } from './detalhes.component';
import { NgxGalleryModule } from 'ngx-gallery';
import { FormsModule } from '@angular/forms'; // <-- NgModel lives here

@NgModule({
  imports: [
    CommonModule,
    NgxGalleryModule,
    FormsModule
  ],
  declarations: [DetalhesComponent]
})
export class DetalhesModule { }
